module.exports = __webpack_public_path__ + "static/media/mira.5ebca67e.jpg";